/** Client-side mirror of scripts/site-urls.mjs */
export const SITE_ORIGIN = 'https://thinkincode.co.za';
export const HOME_URL = `${SITE_ORIGIN}/`;
export const WORKS_GALLERY_PATH = '/portfolio/explore/';
export const INSIGHTS_HUB_PATH = '/insights/';

const ASSET_EXT = /\.[a-z0-9]{2,5}$/i;

function splitPathAndSuffix(path: string) {
  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const queryIndex = withoutHash.indexOf('?');
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';
  const pathname = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  return { pathname, query, hash };
}

export function sitePath(path: string): string {
  if (!path || path === '/') return '/';
  if (path.startsWith('/#')) return path;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path);
      if (url.origin === SITE_ORIGIN) {
        return sitePath(`${url.pathname}${url.search}${url.hash}`);
      }
    } catch {
      return path;
    }
    return path;
  }

  if (path === '/works' || path === '/works/') return WORKS_GALLERY_PATH;

  const { pathname, query, hash } = splitPathAndSuffix(path);
  if (ASSET_EXT.test(pathname)) return path;

  const trimmed = pathname.replace(/\/+$/, '');
  if (trimmed === '') return `/${query}${hash}`;

  return `${trimmed}/${query}${hash}`;
}

export function canonicalUrl(path: string): string {
  if (!path) return HOME_URL;

  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path);
      if (url.origin === SITE_ORIGIN) {
        return canonicalUrl(`${url.pathname}${url.search}`);
      }
    } catch {
      return path;
    }
    return path;
  }

  const relative = sitePath(path.split('#')[0].split('?')[0]);
  if (relative === '/') return HOME_URL;
  return `${SITE_ORIGIN}${relative}`;
}
